import { render, staticRenderFns } from "./indexOrder.vue?vue&type=template&id=2efa6fa1&"
import script from "./indexOrder.vue?vue&type=script&lang=js&"
export * from "./indexOrder.vue?vue&type=script&lang=js&"
import style0 from "./indexOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports